import moment from 'moment/moment';

export const dateFormat = (date: string) => moment(date).format('dddd Do MMM, YYYY');
